var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploading"},[_vm._v(" 上傳中... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }